import { toast } from 'sonner';

/**
 * Display a success toast notification
 * @param message - The success message to display
 * @param description - Optional description text
 */
export const showSuccessToast = (message: string, description?: string) => {
  toast.success(message, {
    description,
  });
};

/**
 * Display an error toast notification
 * @param message - The error message to display
 * @param description - Optional description text
 */
export const showErrorToast = (message: string, description?: string) => {
  toast.error(message, {
    description,
  });
};

/**
 * Display a promise toast that updates based on promise state
 * @param promise - The promise to track
 * @param messages - Messages for loading, success, and error states
 * @returns The promise result
 */
export const showPromiseToast = async <T>(
  promise: Promise<T>,
  messages: {
    loading: string;
    success: string | ((data: T) => string);
    error: string | ((error: unknown) => string);
  },
): Promise<T> => {
  toast.promise(promise, messages);
  return promise;
};
